module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am497-c180b285d0a94c8d6764b858bd348354.jpg";